import { useBrand } from "@/brand";

const commitments = [
  {
    title: "Ingen skjulte marginer",
    text: "Kun 3 øre påslag og 49 kr fast månedsavgift på Flexsikring-avtalen.",
  },
  {
    title: "Rask og kompetent rådgivning",
    text: "Du snakker direkte med rådgivere som forstår næringslivets utfordringer.",
  },
  {
    title: "100% Grønt miljøansvar",
    text: "Opprinnelsesgaranti medfølger alltid, uten ekstra gebyrer.",
  },
];

const AboutSection = () => {
  const brand = useBrand();
  return (
  <section id="om-oss" className="py-24 bg-white border-b border-slate-200" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">
            Om selskapet
          </span>
          <h2 className="font-serif-heading text-3xl sm:text-4xl font-bold text-[#0B132B] mt-2 mb-6">
            En uavhengig kraftpartner for norske bedrifter
          </h2>
          <div className="space-y-4 text-slate-600 leading-relaxed text-sm">
            <p>
              {brand.companyLine} ble etablert med ett klart formål: å gi norske
              virksomheter en mer profesjonell, forutsigbar og transparent
              strømleveranse.
            </p>
            <p>
              I et kraftmarked preget av uoversiktlige avtaler og store
              prissvingninger, jobber våre analytikere kontinuerlig med å
              planlegge innkjøp i Nasdaq og Nordpool over tid. Slik oppnår
              kundene våre en mer stabil og konkurransedyktig pris enn ved ren
              spotpris.
            </p>
            <p>{brand.registration}</p>
          </div>

          <div className="mt-8 grid grid-cols-2 gap-6 pt-6 border-t border-slate-200">
            <div>
              <div className="text-xs font-semibold text-slate-500 uppercase">
                Organisasjonsnummer
              </div>
              <div className="text-base font-bold text-[#0B132B] mt-1" data-testid="about-org-number">
                937 756 763
              </div>
            </div>
            <div>
              <div className="text-xs font-semibold text-slate-500 uppercase">Målgruppe</div>
              <div className="text-base font-bold text-[#0B132B] mt-1">
                Bedrifter og privatkunder
              </div>
            </div>
          </div>
        </div>

        <div className="p-8 rounded-2xl bg-slate-50 border border-slate-200">
          <h3 className="text-xl font-bold text-[#0B132B] mb-4">
            Våre forpliktelser til din bedrift
          </h3>
          <div className="space-y-4">
            {commitments.map((c) => (
              <div key={c.title} className="flex items-start gap-4">
                <div>
                  <h4 className="text-sm font-bold text-slate-900">{c.title}</h4>
                  <p className="text-xs text-slate-600 mt-1">{c.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default AboutSection;
